module.exports = require("./dist/worker/index")
